module.exports = " <div class=page_error> <img src=" + require("../assets/images/404.png") + " v-if=\"$route.query.type === '404'\"/> <div class=error_tips v-if=\"$route.query.type === 'error'\"> <img src=" + require("../assets/images/error.png") + " /> <p><span>加载应用数据失败！</span><a href=# @click.prevent=backToPrevRouter()>重新加载</a></p> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/error.vue
 ** module id = 57
 ** module chunks = 1
 **/